export default {"src":"/_next/static/media/food.1f87a18a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};